import { useEffect } from "react";

const CRISP_ID = process.env.REACT_APP_CRISP_WEBSITE_ID || "";

/**
 * Widget de chat de soporte (Crisp). Solo se carga si REACT_APP_CRISP_WEBSITE_ID
 * está definida en el entorno — sin la variable, el componente es un no-op y no
 * se inyecta ningún script de terceros.
 */
export default function SupportChat() {
  useEffect(() => {
    if (!CRISP_ID || window.$crisp) return;
    window.$crisp = [["safe", true]];
    window.CRISP_WEBSITE_ID = CRISP_ID;
    const script = document.createElement("script");
    script.src = "https://client.crisp.chat/l.js";
    script.async = true;
    document.head.appendChild(script);
  }, []);

  return null;
}
